namespace GeniuzPOS.ReportMasterData {
    export interface Report_1405Form {
    }

    export class Report_1405Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1405';
    }
}
